import { render, staticRenderFns } from "./ChatMessageModalStatus.vue?vue&type=template&id=55308d14"
import script from "./ChatMessageModalStatus.vue?vue&type=script&lang=js"
export * from "./ChatMessageModalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports